//
// The system roles of SkillControl. Mirrored by numeric value from the API (Security/Permissions/Roles.cs).
// Admin=1 and OrgAdmin=98 keep their ISOPlanner values so the copied policies stay the same.
//
export enum appRoles {
  User = 0,
  Admin = 1,
  SkillOwner = 2,
  SkillApprover = 3,
  SecurityReviewer = 4,
  OrgAdmin = 98,
  TenantAdmin = 997,
}

// Handy sets of used app role combinations
export enum appRoleSetTypes {
  Users = 0,
  Managers = 1,
  Admins = 2,
  TenantAdmins = 3,
  Licensed = 4,
  SkillOwners = 5,
  SkillApprovers = 6,
  PolicyReaders = 7,
  AuditReaders = 8,
  UserReaders = 9,
  AssignableRoles = 10,
  AdminManagedRoles = 11,
}

export const appRoleSets: Record<appRoleSetTypes, appRoles[]> = {
  [appRoleSetTypes.Users]: [
    appRoles.User,
    appRoles.Admin,
    appRoles.SkillOwner,
    appRoles.SkillApprover,
    appRoles.SecurityReviewer,
    appRoles.OrgAdmin,
    appRoles.TenantAdmin,
  ],
  //the roles that manage something in the organization: its skills, their approval, their security review
  [appRoleSetTypes.Managers]: [
    appRoles.Admin,
    appRoles.SkillOwner,
    appRoles.SkillApprover,
    appRoles.SecurityReviewer,
    appRoles.OrgAdmin,
  ],
  [appRoleSetTypes.Admins]: [appRoles.Admin, appRoles.OrgAdmin],
  [appRoleSetTypes.TenantAdmins]: [appRoles.TenantAdmin],
  [appRoleSetTypes.Licensed]: [
    appRoles.Admin,
    appRoles.SkillOwner,
    appRoles.SkillApprover,
    appRoles.SecurityReviewer,
    appRoles.OrgAdmin,
  ],
  //the API's Roles.SkillOwnerList and Roles.SkillApproverList, behind RequireSkillOwner and RequireSkillApprover
  [appRoleSetTypes.SkillOwners]: [appRoles.SkillOwner, appRoles.Admin, appRoles.OrgAdmin],
  [appRoleSetTypes.SkillApprovers]: [appRoles.SkillApprover, appRoles.Admin, appRoles.OrgAdmin],
  //the API's Roles.PolicyReaderList: the readers of the policies
  [appRoleSetTypes.PolicyReaders]: [appRoles.Admin, appRoles.OrgAdmin, appRoles.SecurityReviewer],
  //the API's Roles.AuditReaderList: the readers of the runtime audit record
  [appRoleSetTypes.AuditReaders]: [appRoles.Admin, appRoles.OrgAdmin, appRoles.SecurityReviewer],
  //the API's Roles.UserReaderList: the readers of Administration > Users; only administrators (Admins) change users
  [appRoleSetTypes.UserReaders]: [appRoles.Admin, appRoles.OrgAdmin, appRoles.SecurityReviewer],
  //the API's UserManager.AssignableRoles, in the order the user editor shows them: User is implicit, TenantAdmin is
  //never assigned inside an organization
  [appRoleSetTypes.AssignableRoles]: [
    appRoles.SkillOwner,
    appRoles.SkillApprover,
    appRoles.SecurityReviewer,
    appRoles.Admin,
    appRoles.OrgAdmin,
  ],
  //the API's UserManager.AdminManagedRoles: the roles an Admin who is no OrgAdmin grants and revokes
  [appRoleSetTypes.AdminManagedRoles]: [appRoles.SkillOwner, appRoles.SkillApprover, appRoles.SecurityReviewer],
};
